import database from '@/Bootstrap/models.js';
import Rules from '@/Store/Rules.js';
import VideoPlayer from '@/Store/VideoPlayer.js';
import VuexORM from '@vuex-orm/core';
import VuexORMAxios from '@vuex-orm/plugin-axios';
import axios from 'axios';
import Vuex from 'vuex';

const store = new Vuex.Store({
    plugins: [VuexORM.install(database)],

    modules: {
        VideoPlayer,
        Rules,
    },

    state: {
        debugMode: false,
        forceHardNavigation: false,
        globalVideoPlayer: {},
        verifiableMeetIds: [],
        pageTitle: '',
    },

    actions: {
        setPageTitle({ commit }, title) {
            commit('SET_PAGE_TITLE', title);
        },
    },

    mutations: {
        SET_DEBUG_MODE(state, debug) {
            state.debugMode = debug;
        },

        SET_FORCE_HARD_NAVIGATION(state, force) {
            state.forceHardNavigation = force;
        },

        SET_GLOBAL_VIDEO_PLAYER(state, player) {
            state.globalVideoPlayer = player;
        },

        SET_VERIFIABLE_MEET_IDS(state, meetIds) {
            state.verifiableMeetIds = meetIds === '*' ? '*' : meetIds.map(meetId => Number.parseInt(meetId, 10));
        },

        ADD_VERIFIABLE_MEET_ID(state, meetId) {
            if (!state.verifiableMeetIds.includes(meetId)) {
                state.verifiableMeetIds.push(meetId);
            }
        },

        REMOVE_VERIFIABLE_MEET_ID(state, meetId) {
            state.verifiableMeetIds = state.verifiableMeetIds.filter(id => id !== meetId);
        },

        SET_PAGE_TITLE(state, title) {
            state.pageTitle = title;
        },
    },
});

VuexORM.use(VuexORMAxios, {
    axios,
    baseURL: '/',
    dataKey: 'data',
});

export default store;
